import * as React from 'react';

export const getDisplayName = (Component: React.ComponentType<any>): string => {
  return Component.displayName || Component.name || 'Unknown';
};
